<template>
  <div class="mine">
    <div class="top">
      <div class="setting">
        <div class="head"><span></span>
          <p></p>
          <i class="van-badge__wrapper van-icon" style="font-size: 28px;margin-top: 10px;" @click="toMail()">
            <img src="/img/home/info.png" class="van-icon__image">
            <div class="van-badge van-badge--fixed" style="top:2px;font-size: 12px;padding: 2px 5px;" v-if ="mail > 0">{{mail > 100? 99 : mail}}</div>
          </i>
        </div>
      </div>
      <div class="avatar"  @click="showSetting()">
        <div class="van-image van-image--round" style="width: 4.2rem; height: 4.2rem;">
          <img :src="userInfo.header_img?userInfo.header_img:'/img/mine/avatar.png'" class="van-image__img" style="object-fit: cover;">
        </div>
        <div class="me">
          <div class="user"><p>{{this.userInfo.username}}<span><span>{{this.userInfo.lv}}</span></span></p>
            <p style="font-size: 13px; margin-bottom: 0px; padding-bottom: 0px;">{{ $t("text.credit_score") }}: {{this.userInfo.credit_score}}</p></div>
          <div class="ps">
            <div class="proess"><span :style="'width: '+(userInfo.credit_score/100)+'%;'"></span></div>
            <span>{{ $t("text.txt25").replace("15",userInfo.next_lv) }}</span></div>
        </div>
        <i class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(255, 255, 255); font-size: 20px;"></i>
      </div>
    </div>
    <div class="center">
      <div class="mineJf">
        <div class="title"><i class="van-badge__wrapper van-icon" style="font-size: 22px;"><img
            src="data:image/png;base64,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"
            class="van-icon__image"></i>
          <p>{{ $t("text.txt26") }} {{userInfo.money}}</p></div>
        <div class="reload" v-if="false">
          <div><span>{{ $t("text.txt27") }}</span><i class="van-badge__wrapper van-icon"><img
              src="data:image/png;base64,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"
              class="van-icon__image1"></i></div>
        </div>
      </div>
      <div class="integral">
        <div @click="doPay()">
          <i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 32px;"><img
            src="/img/mine/czjf.png" class="van-icon__image"></i>
          <div><span>{{ $t("text.txt28") }}</span>
            <p>Recharge points</p></div>
        </div>
        <div  @click="doWithdrawal()">
          <i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 32px;">
            <img src="/img/mine/jfdh.png" class="van-icon__image">
          </i>
          <div>
            <span>{{ $t("text.txt29") }}</span>
            <p>Redeem points</p>
          </div>
        </div>
      </div>
    </div>
    <div class="center cer2" style="margin-top: 0px;">
      <div class="list animate__animated animate__fadeIn">
        <div @click="toService()">
          <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/kefu.png" class="van-icon__image"></i><span>{{ $t("text.txt30") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
        <div @click="showSetting()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/xunxi.png" class="van-icon__image"></i><span>{{ $t("text.txt31") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
        <div  @click="$router.push({path:'/GameRecord'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/jf.png" class="van-icon__image"></i><span>{{ $t("text.txt32") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
        <div @click="$router.push({path:'/WithdrawRecord'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/dh.png" class="van-icon__image"></i><span>{{ $t("text.txt33") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
        <div @click="toLoginPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/dl.png" class="van-icon__image"></i><span>{{ $t("setting.password") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
        <div @click="toPayPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 38px;"><img
            src="/img/mine/dl.png" class="van-icon__image"></i><span>{{ $t("text.txt35") }}</span><i
            class="van-badge__wrapper van-icon van-icon-arrow" style="color: rgb(186, 186, 186); font-size: 20px;"></i>
        </div>
      </div>
      <a class="btns" @click="loginout()">{{ $t("setting.quit") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      mail: 0,
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("msg.请完成任务单后进入"));
    },
    toPayPassword(){
      this.$router.push({path:'/SetPayPassword'});
      /*if(this.userInfo.paypassword !== "未设置"){
        this.$toast(this.$t("msg.提现密码已设置，需要修改请联系客服"));
      }else {
      }*/
    },

    loginout(){
      localStorage.clear();
      localStorage.setItem('lang',this.lang);
      this.$router.push({path:'/Login'});
    },
    toLoginPassword(){
      this.$router.push({path:'/SetLoginPassword'});
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Setting'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Notice'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Infomation'});
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    doPay() {
      this.$toast(this.$t("msg.请联系客服充值"));
      return false;
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })
    },
    toMail() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Mail'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t("msg.功能已禁用!"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          this.mail = res.data.mail;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>

.van-icon__image1 {
  display: block;
  width: 2em;
  height: 2em;
  -o-object-fit: contain;
  object-fit: contain
}
</style>
